function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { Configuration } from "./Components/Shared/Configuration";
import { OAuthService } from "./Components/Services/OAuthService";
import { PendoInitializer } from "./Components/Shared/PendoInitializer";
var observer = new MutationObserver(watchForWidgets);
var tagList = "";
var lazyScripts = [{
  tag: "mpp-about-me",
  script: "/dist/AboutMe.js",
  name: "About Me"
}, {
  tag: "mpp-checkout",
  script: "/dist/Checkout.js",
  name: "Checkout"
}, {
  tag: "mpp-checkout-complete",
  script: "/dist/CheckoutComplete.js",
  name: "Checkout Complete"
}, {
  tag: "mpp-custom-form",
  script: "/dist/MppCustomForm.js",
  name: "Custom Form"
}, {
  tag: "mpp-event-details",
  script: "/dist/EventDetails.js",
  name: "Event Details"
}, {
  tag: "mpp-event-finder",
  script: "/dist/EventFinder.js",
  name: "Event Finder"
}, {
  tag: "mpp-event-registration",
  script: "/dist/EventRegistration.js",
  name: "Event Registration"
}, {
  tag: "mpp-group-details",
  script: "/dist/GroupDetails.js",
  name: "Group Details"
}, {
  tag: "mpp-group-finder",
  script: "/dist/GroupFinder.js",
  name: "Group Finder"
}, {
  tag: "mpp-household",
  script: "/dist/Household.js",
  name: "My Household"
}, {
  tag: "mpp-locale-selector",
  script: "/dist/LocaleSelector.js",
  name: "Locale Selector"
}, {
  tag: "mpp-mission-trip",
  script: "/dist/MissionTrip.js",
  name: "Mission Trip"
}, {
  tag: "mpp-mission-finder",
  script: "/dist/MissionFinder.js",
  name: "Mission Trip Finder"
}, {
  tag: "mpp-my-contribution-statement",
  script: "/dist/MyContributionStatement.js",
  name: "My Contribution Statement"
}, {
  tag: "mpp-my-giving",
  script: "/dist/MyGiving.js",
  name: "My Giving"
}, {
  tag: "mpp-my-groups",
  script: "/dist/MyGroups.js",
  name: "My Groups"
}, {
  tag: "mpp-my-invoices",
  script: "/dist/MyInvoices.js",
  name: "My Invoices"
}, {
  tag: "mpp-my-mission-trips",
  script: "/dist/MyMissionTrips.js",
  name: "My Mission Trips"
}, {
  tag: "mpp-my-pledges",
  script: "/dist/MyPledges.js",
  name: "My Pledges"
}, {
  tag: "mpp-online-directory",
  script: "/dist/OnlineDirectory.js",
  name: "Online Directory"
}, {
  tag: "mpp-opportunity-details",
  script: "/dist/OpportunityDetails.js",
  name: "Opportunity Details"
}, {
  tag: "mpp-opportunity-finder",
  script: "/dist/OpportunityFinder.js",
  name: "Opportunity Finder"
}, {
  tag: "mpp-pay",
  script: "/dist/Pay.js",
  name: "Pay",
  excludeFromConfigurator: true
}, {
  tag: "mpp-plan-your-visit",
  script: "/dist/PlanYourVisit.js",
  name: "Plan Your Visit"
}, {
  tag: "mpp-pledge-campaign",
  script: "/dist/PledgeCampaign.js",
  name: "Pledge Campaigns"
}, {
  tag: "mpp-prayer-feedback-form",
  script: "/dist/PrayerFeedbackForm.js",
  name: "Prayer Feedback"
}, {
  tag: "mpp-pre-check",
  script: "/dist/PreCheck.js",
  name: "Pre Check",
  excludeFromConfigurator: true
}, {
  tag: "mpp-rss-reader",
  script: "/dist/RssReader.js",
  name: "RSS Reader"
}, {
  tag: "mpp-smart-frame",
  script: "/dist/SmartFrame.js",
  name: "Smart Frame"
}, {
  tag: "mpp-smart-link",
  script: "/dist/SmartLink.js",
  name: "Smart Link"
}, {
  tag: "mpp-subscribe-to-publication",
  script: "/dist/SubscribeToPublication.js",
  name: "Subscribe to Publication"
}, {
  tag: "mpp-subscriptions",
  script: "/dist/Subscriptions.js",
  name: "Subscriptions"
}, {
  tag: "mpp-unsubscribe",
  script: "/dist/Unsubscribe.js",
  name: "Unsubscribe from Publications"
}, {
  tag: "mpp-user-label",
  script: "/dist/UserLabels.js",
  name: "User Label"
}, {
  tag: "mpp-user-login",
  script: "/dist/UserLogin.js",
  name: "User Login"
}, {
  tag: "mpp-widget-configurator",
  script: "/dist/WidgetConfigurator.js",
  name: "Widget Configurator",
  excludeFromConfigurator: true
}];
document.addEventListener("DOMContentLoaded", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Promise.all([OAuthService.SaveAuthTokensAsync(), OAuthService.SaveCSRFTokenAsync(), watchForWidgets()]);

        case 2:
          observer.observe(document, {
            subtree: true,
            childList: true,
            attributes: false,
            attributeOldValue: false,
            characterData: false,
            characterDataOldValue: false
          });

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));

function watchForWidgets() {
  return _watchForWidgets.apply(this, arguments);
}

function _watchForWidgets() {
  _watchForWidgets = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var loadJS, loadedTags, scripts, loadPromises, newTagList, config, _appRoot, scriptLoadPromises;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            loadJS = function _loadJS(src) {
              return new Promise(function (resolve, reject) {
                if (!!document.querySelector("script[src=\"".concat(src, "\"]"))) {
                  resolve();
                  return;
                }

                var scriptTag = document.createElement("script");
                scriptTag.setAttribute("src", src);
                scriptTag.onload = resolve;
                scriptTag.onerror = reject;
                document.head.appendChild(scriptTag);
              });
            };

            loadedTags = [];
            scripts = [];
            loadPromises = lazyScripts.map(function (lazy) {
              if (document.querySelector("".concat(lazy.tag, ",.").concat(lazy.tag, "-widget"))) {
                loadedTags.push(lazy.tag.replace('mpp-', ''));
                scripts.push(lazy.script);
              }

              return Promise.resolve();
            });
            newTagList = loadedTags.sort().join("~");

            if (!(newTagList === tagList)) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt("return");

          case 7:
            tagList = newTagList;
            config = new Configuration();
            _appRoot = config.GetAppRoot();
            scriptLoadPromises = scripts.map(function (s) {
              return loadJS("".concat(_appRoot).concat(s))["catch"](function (e) {
                console.error("Error loading script: ".concat(s), e);
              });
            });
            _context2.next = 13;
            return Promise.all([].concat(_toConsumableArray(loadPromises), _toConsumableArray(scriptLoadPromises)));

          case 13:
            _context2.next = 15;
            return PendoInitializer.Initialize(loadedTags);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _watchForWidgets.apply(this, arguments);
}